

const blendHex = require('./blend');

module.exports = (from, to, steps) => {

  steps = Math.max(steps - 2, 0);
  if (steps <= 0) {
    return [from, to];
  }
  let colors = [from];

  let diff = 1 / ~~++steps;
  let percent = diff;
  while (--steps) {
    colors.push(blendHex(from, to, percent * 100));
    percent += diff;
  }
  colors.push(to);
  return colors;

};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/transition.js